<template>
  <b-button
    :variant="variant"
    @click="$emit('click')"
  >
    {{ label }}
  </b-button>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import { FieldCalculationTypes } from '@/types'

const props = {
  definition: {
    type: Object,
    required: true,
  },
}

@Component
export default class FieldButton extends Vue.extend({ props }) {
  get stringifyDefinitionLabel () {
    return this.$typedStore.primary.entities.fieldCalculation.stringifyDefinitionLabel
  }

  get type () {
    return this.definition.type
  }

  get variant () {
    if (this.type === FieldCalculationTypes.FUNCTION) {
      return 'primary'
    } else if (this.type === FieldCalculationTypes.NUMBER) {
      return 'info'
    } else {
      return 'secondary'
    }
  }

  get label () {
    return this.stringifyDefinitionLabel(this.definition)
  }
}

</script>
